import { render } from "./carousel_img.vue?vue&type=template&id=228cde47&scoped=true&ts=true"
import script from "./carousel_img.vue?vue&type=script&lang=ts"
export * from "./carousel_img.vue?vue&type=script&lang=ts"

import "./carousel_img.vue?vue&type=style&index=0&id=228cde47&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-228cde47"]])

export default __exports__